// small class to help build the data structure.
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
var Value = function Value(title, description) {
    "use strict";
    _class_call_check(this, Value);
    this.title = title;
    this.description = description;
};
var HEALTHCARE = function(strictLocalize) {
    return new Value(strictLocalize({
        id: "yrlxV/",
        defaultMessage: [
            {
                type: 0,
                value: "Comprehensive healthcare"
            }
        ]
    }), strictLocalize({
        id: "NeQIhZ",
        defaultMessage: [
            {
                type: 0,
                value: "Including Health, Dental, Vision, and Disability for all our locations."
            }
        ]
    }));
};
var TIME_OFF = function(strictLocalize) {
    return new Value(strictLocalize({
        id: "aWlAnJ",
        defaultMessage: [
            {
                type: 0,
                value: "Time off"
            }
        ]
    }), strictLocalize({
        id: "orFu98",
        defaultMessage: [
            {
                type: 0,
                value: "Paid vacation time, holidays, and company-wide \u201CFaire Fundays.\u201D"
            }
        ]
    }));
};
var PARENTAL_LEAVE = function(strictLocalize) {
    return new Value(strictLocalize({
        id: "PXHIu6",
        defaultMessage: [
            {
                type: 0,
                value: "Parental leave"
            }
        ]
    }), strictLocalize({
        id: "zMyG7Z",
        defaultMessage: [
            {
                type: 0,
                value: "Generous parental and family leave, as well as fertility support benefits."
            }
        ]
    }));
};
var MINDFULNESS = function(strictLocalize) {
    return new Value(strictLocalize({
        id: "Y+cmJh",
        defaultMessage: [
            {
                type: 0,
                value: "Daily mindfulness"
            }
        ]
    }), strictLocalize({
        id: "rFUpLQ",
        defaultMessage: [
            {
                type: 0,
                value: "Optional morning meditation."
            }
        ]
    }));
};
var LEARNING = function(strictLocalize) {
    return new Value(strictLocalize({
        id: "YkqdA/",
        defaultMessage: [
            {
                type: 0,
                value: "Annual learning grant"
            }
        ]
    }), strictLocalize({
        id: "y5QGTC",
        defaultMessage: [
            {
                type: 0,
                value: "For personal and professional development."
            }
        ]
    }));
};
var SPACES = function(strictLocalize) {
    return new Value(strictLocalize({
        id: "yXj4RG",
        defaultMessage: [
            {
                type: 0,
                value: "Thoughtfully designed spaces"
            }
        ]
    }), strictLocalize({
        id: "Et4UMe",
        defaultMessage: [
            {
                type: 0,
                value: "All of our offices have been designed with local in mind\u2014from our architects to our coffee blends."
            }
        ]
    }));
};
var WELLBEING = function(strictLocalize) {
    return new Value(strictLocalize({
        id: "KUkc4X",
        defaultMessage: [
            {
                type: 0,
                value: "Fitness & wellbeing benefits"
            }
        ]
    }), strictLocalize({
        id: "EYOhPg",
        defaultMessage: [
            {
                type: 0,
                value: "Including a monthly credit toward your wellness-related programs."
            }
        ]
    }));
};
var MENTAL_HEALTH = function(strictLocalize) {
    return new Value(strictLocalize({
        id: "mNq9dX",
        defaultMessage: [
            {
                type: 0,
                value: "Mental health benefits"
            }
        ]
    }), strictLocalize({
        id: "mHxdbH",
        defaultMessage: [
            {
                type: 0,
                value: "Including free access to Modern Health therapists and resources."
            }
        ]
    }));
};
var CHARITABLE = function(strictLocalize) {
    return new Value(strictLocalize({
        id: "I+/IVd",
        defaultMessage: [
            {
                type: 0,
                value: "Charitable matching"
            }
        ]
    }), strictLocalize({
        id: "qxEEir",
        defaultMessage: [
            {
                type: 0,
                value: "Faire will match up to US$250 of your charitable donations, every year."
            }
        ]
    }));
};
var CAREER = function(strictLocalize) {
    return new Value(strictLocalize({
        id: "xFwqKG",
        defaultMessage: [
            {
                type: 0,
                value: "Career planning"
            }
        ]
    }), strictLocalize({
        id: "MCy+N/",
        defaultMessage: [
            {
                type: 0,
                value: "Whether you want to grow as a leader, hone your craft, or explore a new discipline, our career framework allows space for you to explore."
            }
        ]
    }));
};
export var FAIRE_BENEFITS = function(strictLocalize) {
    return [
        HEALTHCARE(strictLocalize),
        TIME_OFF(strictLocalize),
        PARENTAL_LEAVE(strictLocalize),
        MINDFULNESS(strictLocalize),
        LEARNING(strictLocalize),
        SPACES(strictLocalize),
        WELLBEING(strictLocalize),
        MENTAL_HEALTH(strictLocalize),
        CHARITABLE(strictLocalize),
        CAREER(strictLocalize)
    ];
};
